import actions from '../../actionTypes';

export default site => {
  return {
    type: actions.EDITED_SITE,
    site
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/editedSite.js